export enum COMPONENTS  {
    FindComplaint,
    ComplaintInfo
  };
  